export default __webpack_public_path__ + "static/media/stearns-logo.c8039754.png";